<template>
  <div class="exercise-solution">
    <div class="view-solution-group">
      <div class="view-solution flex justify-end">
        <div 
          :class="`w-11/12 p-4 border border-solid rounded border-grey-light solution-content`"
        >
          <div class="cursor-pointer" @click.stop="onEdit(solution)" v-if="!showConsole">
            <prism :language="exercise.language">{{ solution.code }}</prism>
            <vs-button class="mt-5 float-right" @click.stop="testSolution">Test this solution</vs-button>
          </div>
          <div v-else>
            <div class="bg-black w-full p-5 terminal-output" v-html="terminal"></div>
            <div class="flex justify-end content-center items-center mt-5">
              <feather-icon
              v-if="!loadingOutput && lastExecutionResponse && !lastExecutionResponse.success"
              icon="XIcon"
              svgClasses="h-7 w-7 color-current text-danger"
              class="mr-4"
            />
            <feather-icon
              v-if="!loadingOutput && lastExecutionResponse && lastExecutionResponse.success"
              icon="CheckIcon"
              svgClasses="h-7 w-7 color-current text-success"
              class="mr-4"
            />
              <div
                class="lds-ring pr-8 mr-4"
                v-if="loadingOutput"
              >
                <div></div><div></div><div></div><div></div>
              </div>
              <vs-button class="float-right" @click.stop="() => { showConsole = false }">Back to solution</vs-button>
            </div>
          </div>
        </div>
        <div class="p-4 cursor-pointer delete-solution" @click.stop="$emit('delete-solution', {solutionId: solution.id})" title="Delete solution"><feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 color-current text-danger"/></div>
      </div>
    </div>
  </div>
</template>
<script>
import Prism from 'vue-prism-component'

export default {
  components: {
    Prism
  },
  props: {
    exercise: Object,
    solution: Object,
    onEdit: Function
  },
  data: () => {
    return {
      showConsole: false,
      terminal: 'loading...',
      loadingOutput: true,
      lastExecutionResponse: null
    }
  },
  methods: {
    async testSolution() {
      try {
        this.loadingOutput = true
        this.showConsole = true
        this.lastExecutionResponse = null
        this.terminal = 'loading...'
        const response = await this.$store.dispatch('exercises/sendSolutionToTest', {
          submitted_code: this.solution.code
        })
        this.terminal = this.formatOutput(response)
        this.lastExecutionResponse = response
        this.loadingOutput = false
      } catch (error) {
        this.showError(error)
      }
    },
    formatOutput(response) {
      let currentOutput = ''
      const exerciseOutput = `<div class="output"><pre>${response.output}</pre></div>`

      const exerciseErrors = `<p class="${
        response.success ? 'info' : 'errors'
      }">${response.errors}</p>`

      const exerciseResume = `<strong>Tests summary</strong><p class="summary">Total: ${response.tests_summary.total}<br />Passed: ${response.tests_summary.passed}<br />Failed: ${response.tests_summary.failed}<br /></p>`

      currentOutput = exerciseOutput + exerciseErrors
      currentOutput += exerciseResume
      return currentOutput
    }
  }
}
</script>
<style lang="scss">
  .exercise-solution {
    .delete-solution {
      height: 45px;
    }
    .terminal-output {
      min-height: 400px;
      color: white;
      font-family: Menlo, Monaco, 'Courier New', monospace;
      font-size: 13px;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      text-rendering: optimizeLegibility;
      overflow: auto;

      .success {
        color: green;
      }
      .error,
      .errors {
        color: red;
      }
      .info {
        color: yellow;
      }
      .output {
        color: white;
      }
      strong {
        margin-top: 10px;
        display: block;
      }
    }
  }
</style>